<template>
  <div id="updated-products-barcodes-view">
    <h1>Updated products barcodes</h1>
    <div :v-if="getProductUpdateBarcodesSuccess && updatedProductsBarcodesData.length > 0" class="product-info-container">
      <div v-for="product in updatedProductsBarcodesData" :key="product.product_id" class="product-info">
        <img v-if="product.barcode_img" :src="`data:image/png;base64,${product.barcode_img}`" class="barcode-img">
        <p v-if="!product.barcode_img" class="missing-img-slug">[CAN'T GENERATE BARCODE IMAGE]</p>
        <div class="product-text-info">
          <p>{{ product.product_id }}</p>
          <p>{{ product.product_name }}</p>
          <p>£{{ product.price }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('products', [
      'updatedProductsBarcodesData',
      'getProductUpdateBarcodesSuccess',
    ]),
  },
  created() {
    this.$store.dispatch('products/getUpdatedProductsBarcodesData', this.$route.params.updateEntityId);
  }
};
</script>


<style>

h1 {
  margin-bottom: 50px;
}

.product-info-container {
  display: flex;
  flex-flow: row wrap;
  max-width: 100%;
}

.product-info {
  margin-bottom: 50px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 450px;
  margin-right: 15px;
  border-bottom: 1px solid #262626;
}

.barcode-img, .missing-img-slug {
  width: 370px;
  height: auto;
  margin: 0;
}

.product-info p {
  font-size: 15pt;
  margin-bottom: 0;
}



</style>



// WEBPACK FOOTER //
// src/views/UpdatedProductsBarcodes.vue